module.exports = __webpack_public_path__ + "static/media/icon_attachment.5ed880cd.svg";